import { render, staticRenderFns } from "./VehicleRegistrationView.vue?vue&type=template&id=1b6ede7b&"
import script from "./VehicleRegistrationView.vue?vue&type=script&lang=js&"
export * from "./VehicleRegistrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports